import SEO from '../../Components/SEO';
import Breadcrumb from '../../Components/Breadcrumb';
import { ActivityLayout } from '../../Components/activity-layout';

const vocabulary = '/Images/vocabulary.webp';

const levels = [
  {
    level: 'B1',
    cards: [
      {
        title: 'Flashcards',
        image: '/Images/flashcards2.webp',
        level: 'B1',
        desc:
          'Words and definitions drawn from speaking topics, filterable by category.',
        links: [
          {
            text: 'Flashcards',
            to: '/flashcards',
          },
        ],
      },
      {
        title: 'Quizzes',
        image: '/Images/quiz1.webp',
        level: 'B1',
        desc: 'Quizzes and games to help you remember words.',
        links: [
          {
            text: 'Quizzes',
            to: '/quizzes',
          },
        ],
      },
      {
        title: 'Vocabulary List',
        image: '/Images/flashcards1.webp',
        level: 'B1',
        desc:
          'Words and definitions drawn from speaking topics, filterable by category.',
        links: [
          {
            text: 'Vocabulary List',
            to: '/vocabulary-exercises/list',
          },
        ],
      },
    ],
  },
];

const Vocabularyexercises = () => {
  return (
    <ActivityLayout
      title="Vocabulary Exercises"
      image={vocabulary}
      intro="Here is a collection of vocabulary exercises to do. The exercises are divided by categories which correspond to exam levels. Each category here has 10 exercises, but there are more once you go to the page. Keep checking back as I am always adding new exercises."
      
      levels={levels}
    >
<SEO
        title="Free English Vocabulary Lesson Plans & Activities for ESL Teachers"
        description="Ready-to-use vocabulary lesson plans for online ESL teachers. Flashcards, word lists, and topic-based activities organized by CEFR level. Perfect for 1-to-1 or group vocabulary lessons."
        name="English Exam Exercises"
        type="article"
        image={vocabulary} />
      <Breadcrumb />
    </ActivityLayout>
  );
};

export default Vocabularyexercises;
